import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// ⚠️ ٤ أكتوبر ٢٠٢٦: الموقع إشعارٌ ثابت بعد إغلاق الحجز والإدارة على الويب —
//  لا شبكة منه إطلاقاً (أُزيل إبلاغ الأعطال إلى /api/log-error وقياس web-vitals).
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
